import defaultCaEs from './default-ca-ES.json';
import defaultDeDe from './default-de-DE.json';
import defaultEnGb from './default-en-GB.json';
import defaultEsEs from './default-es-ES.json';
import defaultFrFr from './default-fr-FR.json';
import defaultItIt from './default-it-IT.json';
import defaultNlNl from './default-nl-NL.json';
import defaultPtPt from './default-pt-PT.json';
import fiFi from './fi-FI.json';
import frBe from './fr-BE.json';
import frCa from './fr-CA.json';
import frCh from './fr-CH.json';
import nlBe from './fr-CH.json';

const translationsFiles = {
    'default-ca-ES': defaultCaEs,
    'default-de-DE': defaultDeDe,
    'default-en-GB': defaultEnGb,
    'default-es-ES': defaultEsEs,
    'default-fr-FR': defaultFrFr,
    'default-it-IT': defaultItIt,
    'default-nl-NL': defaultNlNl,
    'default-pt-PT': defaultPtPt,
    'fi-FI': fiFi,
    'fr-BE': frBe,
    'fr-CA': frCa,
    'fr-CH': frCh,
    'nl-BE': nlBe,
};

export default translationsFiles;
